var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 18.667V24.0003M21.334 16.0003V24.0003M16.0007 10.667V24.0003M26.6673 9.06699V22.9337C26.6673 25.1739 26.6673 26.294 26.2313 27.1496C25.8478 27.9023 25.2359 28.5142 24.4833 28.8977C23.6276 29.3337 22.5075 29.3337 20.2673 29.3337H11.734C9.49377 29.3337 8.37367 29.3337 7.51802 28.8977C6.76537 28.5142 6.15345 27.9023 5.76996 27.1496C5.33398 26.294 5.33398 25.1739 5.33398 22.9337V9.06699C5.33398 6.82678 5.33398 5.70668 5.76996 4.85103C6.15345 4.09838 6.76537 3.48646 7.51802 3.10297C8.37367 2.66699 9.49377 2.66699 11.734 2.66699H20.2673C22.5075 2.66699 23.6276 2.66699 24.4833 3.10297C25.2359 3.48646 25.8478 4.09838 26.2313 4.85103C26.6673 5.70668 26.6673 6.82678 26.6673 9.06699Z",
    stroke: "#38CB89",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.8bc13a5dfa56645989e38b466296bdbb.svg";
export { ForwardRef as ReactComponent };